/* @flow */
import * as React from 'react';

const RawMaterials = props => (
  <svg
    width={113}
    height={94}
    viewBox="0 0 113 94"
    fillRule="evenodd"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="81.126 33.206 86.938 11.592 71.146 9.528 65.761 33.206"
    />
    <polygon stroke="#1C1F34" points="81.126 33.206 86.938 11.592 71.146 9.528 65.761 33.206" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      opacity={0.2}
      points="45.497 68.426 50.214 70.599 52.362 68.426 50.769 65.837 46.864 66.603"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      opacity={0.2}
      points="27.929 60.69 32.646 62.863 34.794 60.69 33.201 58.101 29.296 56.902"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M102.724,79.34 C102.724,72.535 97.208,67.019 90.403,67.019 C83.598,67.019 78.081,72.535 78.081,79.34 C78.081,86.145 83.598,91.661 90.403,91.661 C97.208,91.661 102.724,86.145 102.724,79.34"
    />
    <path
      stroke="#1C1F34"
      d="M102.724,79.34 C102.724,72.535 97.208,67.019 90.403,67.019 C83.598,67.019 78.081,72.535 78.081,79.34 C78.081,86.145 83.598,91.661 90.403,91.661 C97.208,91.661 102.724,86.145 102.724,79.34 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M97.969,79.34 C97.969,75.161 94.581,71.773 90.402,71.773 C86.223,71.773 82.835,75.161 82.835,79.34 C82.835,83.519 86.223,86.907 90.402,86.907 C94.581,86.907 97.969,83.519 97.969,79.34"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      points="2.143 48.203 11.792 48.203 11.792 42.505 2.143 42.505"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M92.953,78.463 C92.698,77.804 92.201,77.285 91.555,77.001 L10.77,42.505 L10.57,42.505 L10.57,48.224 L89.412,81.864 C89.751,82.012 90.109,82.088 90.476,82.088 C91.523,82.088 92.473,81.469 92.906,80.484 C93.191,79.838 93.208,79.12 92.953,78.463"
    />
    <path
      stroke="#1C1F34"
      d="M90.475,82.088 C90.108,82.088 89.75,82.013 89.412,81.864 L10.569,48.224 L4.342,48.224 C2.775,48.224 1.5,46.949 1.5,45.382 C1.5,43.781 2.775,42.506 4.342,42.506 L10.77,42.506 L91.555,77.002 C92.2,77.286 92.697,77.805 92.952,78.463 C93.208,79.12 93.191,79.838 92.906,80.484 C92.472,81.47 91.522,82.088 90.475,82.088 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M98.497,39.219 L28.312,39.219 C26.823,39.219 25.616,38.012 25.616,36.523 L25.616,35.898 C25.616,34.409 26.823,33.202 28.312,33.202 L98.497,33.202 C99.986,33.202 101.193,34.409 101.193,35.898 L101.193,36.523 C101.193,38.012 99.986,39.219 98.497,39.219"
    />
    <path
      stroke="#1C1F34"
      d="M98.497,39.219 L28.312,39.219 C26.823,39.219 25.616,38.012 25.616,36.523 L25.616,35.898 C25.616,34.409 26.823,33.202 28.312,33.202 L98.497,33.202 C99.986,33.202 101.193,34.409 101.193,35.898 L101.193,36.523 C101.193,38.012 99.986,39.219 98.497,39.219 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M33.603,52.255 C29.294,50.415 29.294,39.218 29.294,39.218 L98.25,39.218 L83.317,58.564 C83.317,58.564 74.122,70.252 63.752,65.13 L33.603,52.255 Z"
    />
    <path
      stroke="#3A427C"
      d="M33.603,52.255 C29.294,50.415 29.294,39.218 29.294,39.218 L98.25,39.218 L83.317,58.564 C83.317,58.564 74.122,70.252 63.752,65.13 L33.603,52.255 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M29.959,40.665 C29.966,41.259 29.975,41.853 29.977,42.447 C30.192,42.753 30.362,43.088 30.508,43.435 C30.676,43.514 30.835,43.599 30.988,43.694 L94.662,43.694 C94.91,43.232 95.216,42.81 95.577,42.47 C95.836,42.226 96.072,41.963 96.301,41.694 C96.488,41.439 96.675,41.184 96.867,40.933 C96.922,40.838 96.988,40.755 97.048,40.665 L29.959,40.665 Z"
      opacity={0.2}
    />
    <path
      stroke="#1C1F34"
      d="M33.603,52.255 C29.294,50.415 29.294,39.218 29.294,39.218 L98.25,39.218 L83.317,58.564 C83.317,58.564 74.122,70.252 63.752,65.13 L33.603,52.255 Z"
    />
    <path
      stroke="#1C1F34"
      d="M53.657,66.609 L36.201,89.899 C33.674,93.27 28.309,91.483 28.309,87.27 L28.309,55.899"
    />
    <polyline stroke="#1C1F34" points="48.722 64.503 33.604 84.673 33.604 58.052" />
    <path
      stroke="#1C1F34"
      d="M66.359,24.654 C65.673,23.995 65.557,22.637 64.79,22.072 C64.025,21.51 63.273,20.75 62.437,20.289 C61.646,19.854 60.804,19.244 59.956,18.908 C59.118,18.577 57.816,19.503 56.931,19.276 C56.06,19.054 55.13,19.486 54.22,19.372 C53.331,19.261 52.535,19.239 51.615,19.239 C50.595,19.239 49.552,18.117 48.569,18.253 C47.562,18.393 46.678,19.094 45.72,19.367 C44.746,19.645 43.634,19.539 42.721,19.945 C41.798,20.355 41.412,21.702 40.562,22.232 C39.706,22.766 38.165,22.325 37.395,22.969 C36.623,23.614 36.131,24.618 35.455,25.363 C34.781,26.107 34.751,27.323 34.184,28.156 C33.62,28.984 32.704,29.558 32.257,30.464 C31.815,31.36 30.953,32.118 30.636,33.079"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="79.854 33.201 108.306 4.577 111.524 8.589 96.967 33.202"
    />
    <polygon stroke="#1C1F34" points="79.854 33.201 108.306 4.577 111.524 8.589 96.967 33.202" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="74.394 33.201 93.514 1.5 108.307 4.577 91.35 33.202"
    />
    <polygon stroke="#1C1F34" points="74.394 33.201 93.514 1.5 108.307 4.577 91.35 33.202" />
    <polyline stroke="#1C1F34" points="95.16 11.733 93.672 7.707 84.974 3.712" />
    <path stroke="#1C1F34" d="M85.269,2.411 L84.095,4.353" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="48.525 33.202 74.195 18.395 83.87 23.798 71.183 33.202"
    />
    <polygon stroke="#1C1F34" points="48.525 33.202 74.195 18.395 83.87 23.798 71.183 33.202" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="67.696 33.202 83.871 23.798 86.184 28.201 77.66 33.202"
    />
    <polygon stroke="#1C1F34" points="67.696 33.202 83.871 23.798 86.184 28.201 77.66 33.202" />
  </svg>
);

export default RawMaterials;



// WEBPACK FOOTER //
// ./src/assets/images/icons/raw-materials.js